import React from 'react';
import AnalyticsView from './AnalyticsView';

const AnalyticsPage: React.FC = () => <AnalyticsView />;

export default AnalyticsPage;
